export const localStorageKey = 'otp-value'
